
import React from "react";


const Thankyou = () => {
  return (
    <div className="thanks">
          
   
      <h1>Thank You!</h1>
      <p>Thank you for completing the trial signup, we will send you an email once your trial image is completed.</p>
      <p>You can access your completed images by logging into your account with this link  <a href="https://pixelbyhand.com/user-login/">Login</a></p>
       
    </div>
  );
};

export default Thankyou;







